import React, { FunctionComponent } from 'react';

export interface InputProps {
    label?: string;
    name: string;
    defaultValue?: any;
    id: string;
    placeholder?: string;
    register: any;
    validation?: any;
    hasError?: any;
    type?: string;
    helperLabel?: string;
    value?: string;
}

export const Input: FunctionComponent<InputProps> = ({
    label,
    name,
    defaultValue,
    id,
    placeholder,
    register,
    validation,
    hasError,
    type = 'text',
    helperLabel,
}) => {
    const registerProps = register(name, validation ? validation : {});
    return (
        <div className={`c-input ${hasError ? 'input--has-error' : ''}`}>
            {label && (
                <label className="input__label" htmlFor={id}>
                    {label}
                </label>
            )}

            <input
                className="input__input"
                type={type}
                id={id}
                placeholder={placeholder}
                defaultValue={defaultValue}
                {...registerProps}
                onChange={(e) => {
                    if (validation && validation.overwriteOnChange) {
                        registerProps.onChange(e);
                        validation.overwriteOnChange(e);
                    } else {
                        registerProps.onChange(e);
                    }
                }}
                onKeyUp={validation && validation.onKeyUp}
                onFocus={validation && validation.onFocus}
                autoComplete="off"
            />
            {helperLabel && <span className="input__helper-label">{helperLabel}</span>}
        </div>
    );
};
